import { BaseDivider } from "@/shared/ui/base-divider";
import { OfferCargoStatusBadge } from "@/widgets/offer-cargo-status-badge";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "@tanstack/react-router";
import type { CargoTableData } from "../../../../ui/CargoTable/utils";
import { Badge } from "./badge";
import { BorderedGrid, BorderedGridItem } from "./bordered-grid";

type Props = {
  data: CargoTableData;
};

export const MobileCargoListItem: React.FC<Props> = ({ data }) => {
  return (
    <Box
      key={data.id}
      sx={{
        backgrounColor: "white",
        boxShadow: "0px 1px 10px 0px #0000001A",
        borderRadius: "18px",
        border: "1px solid #E4E5E5",
        p: 1.5,
      }}
    >
      <Stack direction="column" gap={1.5}>
        {/* 積日時～卸日時 */}
        <Box
          sx={{
            alignSelf: "stretch",
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            gap: 0.5,
          }}
        >
          <Stack direction="column" gap={0.5} alignItems="flex-start">
            <Badge label="積日時 / 積地" />
            <Typography fontSize="14px" fontWeight={700} color="grey.900">
              {data.startAt}
            </Typography>
            <Typography fontSize="12px" color="grey.500">
              {data.departure}
            </Typography>
          </Stack>

          <ArrowForwardIcon
            width={20}
            height={20}
            sx={{
              marginTop: "26px",
            }}
          />

          <Stack direction="column" gap={0.5} alignItems="flex-start">
            <Badge label="卸日時 / 卸地" />
            <Typography fontSize="14px" fontWeight={700} color="grey.900">
              {data.endAt}
            </Typography>
            <Typography fontSize="12px" color="grey.500">
              {data.destination}
            </Typography>
          </Stack>
        </Box>

        <BaseDivider />

        {/* 経由地～ボディタイプ */}
        <Stack direction="column" gap={1.5}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Badge label="経由地" />

            {data.transitCount > 0 ? (
              <Typography fontSize="14px" fontWeight={700} color="grey.900">
                {data.transitCount}
              </Typography>
            ) : (
              <Typography fontSize="14px" fontWeight={700} color="grey.300">
                ー
              </Typography>
            )}

            <Badge label="車両" />

            <Typography fontSize="12px" color="grey.900">
              {data.vehicle}
            </Typography>
          </Stack>
        </Stack>

        {/* 受付状況など */}
        <BorderedGrid>
          <BorderedGridItem size={4}>受付状況</BorderedGridItem>
          <BorderedGridItem size={4}>受付期限</BorderedGridItem>
          <BorderedGridItem size={4}>提案数</BorderedGridItem>

          <BorderedGridItem size={4}>
            {data.shipperReceptionStatus.status === "loading" ||
            data.carrierReceptionStatus.status === "loading" ? (
              <CircularProgress size={16} />
            ) : data.shipperReceptionStatus.data &&
              data.carrierReceptionStatus.data ? (
              <Stack direction="row" spacing={0.5}>
                <OfferCargoStatusBadge
                  statusType="offer_cargo_process_reception"
                  status={data.shipperReceptionStatus.data}
                />
                <OfferCargoStatusBadge
                  statusType="offer_cargo_process_reception"
                  status={data.carrierReceptionStatus.data}
                />
              </Stack>
            ) : (
              <Typography fontSize="12px" color="grey.900">
                ー
              </Typography>
            )}
          </BorderedGridItem>
          <BorderedGridItem size={4}>
            {data.expiration.replace(/^\d\d\d\d\//, "")}
          </BorderedGridItem>
          <BorderedGridItem size={4}>
            {data.proposalCount.status === "loading" ? (
              <CircularProgress size={16} />
            ) : data.proposalCount.data ? (
              <Typography fontSize="18px" fontWeight={700} color="grey.900">
                {data.proposalCount.data}
              </Typography>
            ) : (
              <Typography fontSize="18px" fontWeight={700} color="grey.300">
                ー
              </Typography>
            )}
          </BorderedGridItem>
        </BorderedGrid>

        <Button
          component={Link}
          to={`/admin/cargos/${data.id}`}
          sx={{
            alignSelf: "stretch",
            position: "relative",
            py: "10px",
            borderRadius: "24px",
            backgroundColor: "grey.100",
            fontSize: "14px",
            fontWeight: 700,
            color: "grey.900",
          }}
        >
          荷物詳細を確認
          <ChevronRightIcon
            width={20}
            height={20}
            sx={{ position: "absolute", right: "10px", top: "10px" }}
          />
        </Button>
      </Stack>
    </Box>
  );
};
